export interface DonorActivity {
  id: string;
  name: string;
  avatar: string;
  amount: number;
  campaignTitle: string;
  date: string;
  isAnonymous: boolean;
  message?: string;
}

export interface MonthlyData {
  month: string;
  amount: number;
  donors: number;
}

export interface Notification {
  id: string;
  type: 'donation' | 'milestone' | 'review' | 'tip' | 'expiry' | 'goal';
  message: string;
  detail?: string;
  time: string;
  date: string;
  isRead: boolean;
  campaignTitle?: string;
  campaignId?: string;
  amount?: number;
}

export const monthlyData: MonthlyData[] = [
  { month: 'أكتوبر', amount: 4200, donors: 38 },
  { month: 'نوفمبر', amount: 6800, donors: 55 },
  { month: 'ديسمبر', amount: 9100, donors: 72 },
  { month: 'يناير', amount: 7400, donors: 61 },
  { month: 'فبراير', amount: 11200, donors: 89 },
  { month: 'مارس', amount: 14800, donors: 112 },
];

export const recentDonors: DonorActivity[] = [
  {
    id: '1',
    name: 'خالد العمري',
    avatar: 'https://readdy.ai/api/search-image?query=Saudi%20man%20portrait%20professional%20clean%20background%20warm&width=60&height=60&seq=601&orientation=squarish',
    amount: 500,
    campaignTitle: 'دعم مشروع تطبيق تعليمي للأطفال',
    date: 'منذ ساعتين',
    isAnonymous: false,
    message: 'مشروع رائع، بالتوفيق!',
  },
  {
    id: '2',
    name: 'داعم مجهول',
    avatar: 'https://readdy.ai/api/search-image?query=anonymous%20person%20silhouette%20clean%20background%20minimal&width=60&height=60&seq=602&orientation=squarish',
    amount: 200,
    campaignTitle: 'دعم مشروع تطبيق تعليمي للأطفال',
    date: 'منذ 5 ساعات',
    isAnonymous: true,
  },
  {
    id: '3',
    name: 'نورة السبيعي',
    avatar: 'https://readdy.ai/api/search-image?query=Saudi%20woman%20hijab%20portrait%20professional%20clean%20background%20warm&width=60&height=60&seq=603&orientation=squarish',
    amount: 1000,
    campaignTitle: 'دعم مشروع تطبيق تعليمي للأطفال',
    date: 'أمس',
    isAnonymous: false,
    message: 'جزاك الله خيراً على هذا المشروع المفيد',
  },
  {
    id: '4',
    name: 'عبدالرحمن الحربي',
    avatar: 'https://readdy.ai/api/search-image?query=Saudi%20young%20man%20portrait%20clean%20background%20casual%20warm%20smile&width=60&height=60&seq=604&orientation=squarish',
    amount: 150,
    campaignTitle: 'دعم مشروع تطبيق تعليمي للأطفال',
    date: 'منذ يومين',
    isAnonymous: false,
  },
  {
    id: '5',
    name: 'ريم الدوسري',
    avatar: 'https://readdy.ai/api/search-image?query=Saudi%20woman%20portrait%20professional%20clean%20background%20elegant%20warm&width=60&height=60&seq=605&orientation=squarish',
    amount: 300,
    campaignTitle: 'دعم مشروع تطبيق تعليمي للأطفال',
    date: 'منذ 3 أيام',
    isAnonymous: false,
    message: 'استمر في العطاء!',
  },
];

export const notifications: Notification[] = [
  {
    id: '1',
    type: 'donation',
    message: 'تبرع جديد بمبلغ 500 ر.س',
    detail: 'خالد العمري تبرع لحملة "تطبيق تعليمي للأطفال"',
    time: 'منذ ساعتين',
    date: 'اليوم',
    isRead: false,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
    amount: 500,
  },
  {
    id: '2',
    type: 'donation',
    message: 'تبرع جديد بمبلغ 1,000 ر.س',
    detail: 'نورة السبيعي تبرعت لحملة "تطبيق تعليمي للأطفال"',
    time: 'منذ 4 ساعات',
    date: 'اليوم',
    isRead: false,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
    amount: 1000,
  },
  {
    id: '3',
    type: 'milestone',
    message: 'وصلت حملتك إلى 75% من الهدف!',
    detail: 'حملة "تطبيق تعليمي للأطفال" جمعت 37,500 ر.س من أصل 50,000 ر.س',
    time: 'منذ 6 ساعات',
    date: 'اليوم',
    isRead: false,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
  },
  {
    id: '4',
    type: 'expiry',
    message: 'حملتك تنتهي خلال 5 أيام',
    detail: 'حملة "تطبيق تعليمي للأطفال" ستنتهي في 17 أبريل 2026 — شارك الحملة لزيادة الدعم',
    time: 'منذ 8 ساعات',
    date: 'اليوم',
    isRead: false,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
  },
  {
    id: '5',
    type: 'donation',
    message: 'تبرع جديد بمبلغ 200 ر.س',
    detail: 'داعم مجهول تبرع لحملة "تطبيق تعليمي للأطفال"',
    time: 'أمس، 11:30 م',
    date: 'أمس',
    isRead: true,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
    amount: 200,
  },
  {
    id: '6',
    type: 'review',
    message: 'تمت الموافقة على حملتك ونشرها',
    detail: 'حملة "تطبيق تعليمي للأطفال" اجتازت المراجعة وأصبحت متاحة للجمهور',
    time: 'أمس، 9:00 ص',
    date: 'أمس',
    isRead: true,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
  },
  {
    id: '7',
    type: 'goal',
    message: 'تجاوزت حملتك الهدف الأول 🎉',
    detail: 'حملة "ورشة تصوير إبداعي" تجاوزت هدفها الأول وجمعت 15,000 ر.س',
    time: 'منذ 3 أيام',
    date: 'الأسبوع الماضي',
    isRead: true,
    campaignTitle: 'ورشة تصوير إبداعي',
    campaignId: '2',
  },
  {
    id: '8',
    type: 'milestone',
    message: 'وصلت حملتك إلى 50% من الهدف',
    detail: 'حملة "ورشة تصوير إبداعي" وصلت لنصف الطريق — استمر في المشاركة!',
    time: 'منذ 5 أيام',
    date: 'الأسبوع الماضي',
    isRead: true,
    campaignTitle: 'ورشة تصوير إبداعي',
    campaignId: '2',
  },
  {
    id: '9',
    type: 'tip',
    message: 'نصيحة: أضف تحديثاً لحملتك',
    detail: 'الحملات التي تنشر تحديثات دورية تحصل على 40% تبرعات أكثر — شارك جديدك مع داعميك',
    time: 'منذ أسبوع',
    date: 'الأسبوع الماضي',
    isRead: true,
  },
  {
    id: '10',
    type: 'review',
    message: 'حملتك قيد المراجعة',
    detail: 'تم استلام حملة "تطبيق تعليمي للأطفال" وسيتم مراجعتها خلال 24-48 ساعة',
    time: 'منذ أسبوعين',
    date: 'هذا الشهر',
    isRead: true,
    campaignTitle: 'تطبيق تعليمي للأطفال',
    campaignId: '1',
  },
];

export interface WithdrawalRecord {
  id: string;
  amount: number;
  fee: number;
  net: number;
  status: 'completed' | 'pending' | 'processing';
  date: string;
  bankName: string;
  accountLast4: string;
  reference: string;
}

export const withdrawalHistory: WithdrawalRecord[] = [
  {
    id: 'w1',
    amount: 15000,
    fee: 750,
    net: 14250,
    status: 'completed',
    date: '2026-03-15',
    bankName: 'بنك الراجحي',
    accountLast4: '4821',
    reference: 'WD-2026-0315-001',
  },
  {
    id: 'w2',
    amount: 8500,
    fee: 425,
    net: 8075,
    status: 'completed',
    date: '2026-02-20',
    bankName: 'بنك الراجحي',
    accountLast4: '4821',
    reference: 'WD-2026-0220-002',
  },
  {
    id: 'w3',
    amount: 5200,
    fee: 260,
    net: 4940,
    status: 'completed',
    date: '2026-01-10',
    bankName: 'بنك الراجحي',
    accountLast4: '4821',
    reference: 'WD-2026-0110-003',
  },
  {
    id: 'w4',
    amount: 3800,
    fee: 190,
    net: 3610,
    status: 'completed',
    date: '2025-12-05',
    bankName: 'بنك الراجحي',
    accountLast4: '4821',
    reference: 'WD-2025-1205-004',
  },
  {
    id: 'w5',
    amount: 30875,
    fee: 0,
    net: 30875,
    status: 'pending',
    date: '2026-04-13',
    bankName: 'بنك الراجحي',
    accountLast4: '4821',
    reference: 'WD-2026-0413-005',
  },
];

export const dashboardProfile = {
  username: 'ahmed_shamri',
  displayName: 'أحمد الشمري',
  avatar: 'https://readdy.ai/api/search-image?query=professional%20Saudi%20man%20portrait%20clean%20background%20warm%20lighting%20confident%20smile&width=200&height=200&seq=301&orientation=squarish',
  isVerified: true,
  category: 'تقنية وتعليم',
  totalRaised: 32500,
  totalDonors: 248,
  activeCampaigns: 1,
  completedCampaigns: 1,
  platformFeeRate: 0.05,
  platformFee: 1625,
  pendingWithdrawal: 30875,
  successRate: 87,
};
